import React from 'react'
import { useSelector } from 'react-redux'

import spacetime from 'spacetime'

import { Card, Text } from '@driftt/dds'

import usePresenceSubscription from 'hooks/usePresenceSubscription'
import { ActivityEndUser, ActivityEvent, ActivityType } from 'modules/accountActivity/domain'
import { getCurrentOrg } from 'selectors'

import { EndUserActivity } from './ActivityCards/EndUserActivity'
import { MeetingActivity } from './ActivityCards/MeetingActivity'

interface ActivityGroupProps {
  endUserData: Record<number, ActivityEndUser>
  activities: ActivityEvent[]
  trackAction: (action: string, additionalData?: any) => void
}

const renderActivity = (
  activityEvent: ActivityEvent,
  endUserData: ActivityEndUser,
  presentEndUserIds: Set<number>,
  trackAction: (action: string, additionalData?: any) => void
) => {
  switch (activityEvent.activityType) {
    case ActivityType.PAGE_VIEW:
    case ActivityType.VIDEO:
    case ActivityType.EMAIL_OPEN:
    case ActivityType.EMAIL_OPEN_SFDC:
    case ActivityType.EMAIL_CLICK:
    case ActivityType.EMAIL_CLICK_SFDC:
    case ActivityType.EMAIL_INBOUND:
    case ActivityType.END_USER_IDENTIFIED:
    case ActivityType.SMS_INBOUND:
    case ActivityType.OTHER_CHATBOT_CONVERSATION:
    case ActivityType.FILLED_OUT_FORM:
    case ActivityType.UNSUBSCRIBED:
    case ActivityType.CONTRACT_REQUEST:
    case ActivityType.WEBINAR:
    case ActivityType.WIDGET_CONTENT_CLICK:
    case ActivityType.WIDGET_SEARCH_SEND:
    case ActivityType.ADDED:
      return (
        <EndUserActivity
          activityEvent={activityEvent}
          endUserData={endUserData}
          presentEndUserIds={presentEndUserIds}
          trackAction={trackAction}
        />
      )
    case ActivityType.CONVERSATION:
      return (
        <EndUserActivity
          activityEvent={activityEvent}
          endUserData={endUserData}
          align="center"
          presentEndUserIds={presentEndUserIds}
          trackAction={trackAction}
        />
      )
    case ActivityType.MEETING_BOOKED:
    case ActivityType.MEETING_CANCELED:
    case ActivityType.MEETING_RESCHEDULED:
    case ActivityType.MEETING_RECORDED:
      return (
        <MeetingActivity
          activityEvent={activityEvent}
          presentEndUserIds={presentEndUserIds}
          trackAction={trackAction}
        />
      )
    default:
      return <></>
  }
};

const ActivityGroup = ({ endUserData, activities, trackAction }: ActivityGroupProps) => {
  const org = useSelector(getCurrentOrg)
  const presentEndUserIds = usePresenceSubscription(org.id, Object.values(endUserData))

  const date = activities[0].createdAt
  const s = spacetime(date)
  return (
    <>
      <Card
        css={{
          padding: '4px 16px',
          zIndex: 1,
          marginBottom: '24px'
        }}>
        <Text variant="bodyBold">{s.format('{day}, {month} {date}')}</Text>
      </Card>
      {activities.map(activity => (
        renderActivity(activity, endUserData[activity.endUserId], presentEndUserIds, trackAction)
      ))}
    </>
  )
}

export default ActivityGroup